module.exports = __webpack_public_path__ + "img/zhu.dd6be6ff.jpg";